var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag text-label-mono",class:_vm.tagData.class},[_vm._v(_vm._s(_vm.tagData.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }